import './App.css';
import TrickyTicTacToeCanvas from './trickytictactoecanvas.tsx';
import getTrickyIngredients, { TRICKY_INGREDIENTS } from './getTrickyIngredients.ts';
import React from 'react';

interface TrickyTicTacToeData {
  data: string[]
}

interface TrickyTicTacToeState {
  trickyIngredients?: TRICKY_INGREDIENTS;
  currentChallengeData?: TrickyTicTacToeData;
}

class TrickyTicTacToe extends React.Component<{}, TrickyTicTacToeState> {
  private canvasRef: React.RefObject<HTMLCanvasElement | null>;

  constructor(props: {}) {
    super(props);
    this.canvasRef = React.createRef();
    this.state = {
      trickyIngredients: undefined,
      currentChallengeData: undefined
    }
    this.reloadCanvas = this.reloadCanvas.bind(this)
  }

  async componentDidMount() {
    try {
      const trickyIngredients = await getTrickyIngredients();
      this.setState({ trickyIngredients }, this.reloadCanvas);
    } catch (error) {
      console.error('Error loading tricky ingredients:', error);
    }
  }

  async reloadCanvas() {
    if (this.state.trickyIngredients) {
      try {
        const data = await this.state.trickyIngredients.pickRandom(9);
        this.setState({ currentChallengeData: { data } });
      } catch (error) {
        console.error('Error generating tricky challenge:', error);
      }
    }
  }

  title() {
    return "Here's a Tricky Tic-Tac-Toe Challenge for you...";
  }

  reloadButtonText(): string {
    return "Generate New Tricky Tic-Tac-Toe Challenge";
  }

  render() {
    return (
      <div className="App">
        <div>
          <h2>{this.title()}</h2>
          {this.state.trickyIngredients && this.state.currentChallengeData ? 
            <TrickyTicTacToeCanvas 
              canvasRef={this.canvasRef} 
              trickyIngredients={this.state.trickyIngredients} 
              currentChallengeData={this.state.currentChallengeData} 
            />
            : null}
          <button onClick={this.reloadCanvas}>{this.reloadButtonText()}</button>
          <a className="button-link" href="/">Homepage</a>
        </div>
      </div>
    );
  }
}

export default TrickyTicTacToe;
export type { TrickyTicTacToeData };
